<template>
  <a-drawer width='35%' :label-col='4' :wrapper-col='14' :visible='open' @close='cancel'>
    <a-divider orientation='left'>
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref='form' :model='form' :rules='rules'>
      <a-form-model-item label='App type' prop='appType' >
        <a-select placeholder="Please select" v-model="form.appType" >
          <a-select-option value="0">Android</a-select-option>
          <a-select-option value="1">iOS</a-select-option>
          <a-select-option value="2">Universal</a-select-option>
        </a-select>
<!--        <a-input-number v-model='form.appType' placeholder=' 0安卓 1苹果 2通用' :min='0' :max='2' />-->
      </a-form-model-item>

      <a-form-model-item label='Version name' prop='versionName'
      >
        <a-input v-model='form.versionName' placeholder='Enter version display name (max 15 chars)' :maxLength='15'/>
      </a-form-model-item>
      <a-form-model-item label='Version code' prop='versionCode'
      >
        <a-input v-model='form.versionCode' placeholder='Enter version code' :maxLength='15'/>
      </a-form-model-item>
      <a-form-model-item label='Package size' prop='upHeSize' >
        <a-input-number style="width: 100%;" v-model='form.upHeSize' placeholder='Enter package size' :min='0.01' :maxLength='10' :max='9999'/>
      </a-form-model-item>
      <a-form-model-item label='Update URL type' prop='upUrlType' >
        <a-select placeholder="Please select" v-model="form.upUrlType" >
          <a-select-option value="0">Internal</a-select-option>
          <a-select-option value="1">External (app store)</a-select-option>
        </a-select>
<!--        <a-input-number v-model='form.upUrlType' placeholder=' 更新地址类型: 0内部 1其它(应用市场)' :min='0' :max='1' />-->
      </a-form-model-item>
      <a-form-model-item label='External URL (internal file library)' prop='upUrl'
                         v-if="form.upUrlType == 1"
      >
        <a-input v-model='form.upUrl' placeholder='Enter external app store URL' />
      </a-form-model-item>

      <a-form-model-item label='Update type' prop='upType'
      >
        <a-select placeholder="Please select" v-model="form.upType" >
          <a-select-option value="0">Hot update</a-select-option>
          <a-select-option value="1">Full package</a-select-option>
        </a-select>
<!--        <a-input-number v-model='form.upType' placeholder='0热更新 1整包更新' :min='0' :max='1' />-->

      </a-form-model-item>
      <a-form-model-item label='Force upgrade' prop='compulsoryUp'
      >
        <a-select placeholder="Please select" v-model="form.compulsoryUp" >
          <a-select-option value="0">Required</a-select-option>
          <a-select-option value="1">Optional</a-select-option>
        </a-select>
<!--        <a-input-number v-model='form.compulsoryUp' placeholder='请输入强制升级否 0强制 1可跳过' :min='0' :max='1' />-->

      </a-form-model-item>
<!--      <a-form-model-item label='计划更新时间: 0及时更新 1计划更新' prop='planUpType'-->
<!--      >-->
<!--        <a-input-number v-model='form.planUpType' placeholder='0及时更新 1计划更新' :min='0' :max='1' />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label='计划更新时间' prop='planUpTime'-->
<!--      >-->
<!--        <a-input v-model='form.planUpTime' placeholder='请输入计划更新时间' />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label='Download URL' prop='downloadUrl'
      >
        <a-input v-model='form.downloadUrl' placeholder='Enter download URL' :maxLength='500'/>
<!--        <a-upload   listType='picture-card'-->
<!--                    class='avatar-uploader' :show-upload-list='false' :beforeUpload='(info) => fileBeforeUpload(info)'-->
<!--                    :customRequest='(info) => fileUploadRequest(info)' v-model="form.downloadUrl">-->
<!--          <a-input v-model='form.downloadUrl' :disabled='true' placeholder='请输入下载地址' :maxLength='255'/>-->
<!--          <div v-else>-->
<!--            <a-icon :type="loading ? 'loading' : 'plus'" />-->
<!--            <div class='ant-upload-text'>{{ loading ? '上传中' : '上传' }}</div>-->
<!--          </div>-->
<!--        </a-upload>-->
      </a-form-model-item>
      <a-form-model-item label='Release notes' prop='upNotes' >
        <a-input v-model='form.upNotes' placeholder='Enter release notes' :maxLength='30'/>
      </a-form-model-item>
      <div class='bottom-control'>
        <a-space>
          <a-button type='primary' :loading='submitLoading' @click='submitForm'>
            Save
          </a-button>
          <a-button type='dashed' @click='cancel'>
            Cancel
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVersionInfo, addVersionInfo, updateVersionInfo } from '@/api/app/versionInfo'
import UploadFileToOSS from '@/utils/upload-file-to-oss'
// import {addVersionInfo} from "@/api/app/versionInfo";
// import { Log } from '@/components/crud/Log'
export default {
  name: 'CreateForm',
  props: {} ,
  components: {}
  ,
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        appType: "0",

        upNotes: null,

        upHeSize: null,

        upUrlType: null,

        upUrl: null,

        versionName: null,

        versionCode: null,

        upType: null,

        compulsoryUp: null,

        downloadUrl: null,

        createTime: null,

        remark: null,
       // type:0

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      loading: false,
      apkFileName: null,
      rules: {
        appType: [
          {
            required: true, message: 'App type is required', trigger: 'change'
          }
        ],
        upUrlType: [
          {
            required: true, message: 'Update URL type is required', trigger: 'change'
          }
        ],
        versionCode: [
          {
            required: true, message: 'Version code is required', trigger: 'blur'
          }
        ],
        upType: [
          {
            required: true, message: 'Update type is required', trigger: 'change'
          }
        ],
        compulsoryUp: [
          {
            required: true, message: 'Force upgrade option is required', trigger: 'blur'
          }
        ],

        downloadUrl: [
          {
            required: true, message: 'Download URL is required', trigger: 'blur'
          }
        ]
      }
    }
  }
  ,
  filters: {}
  ,
  created() {
  }
  ,
  computed: {}
  ,
  watch: {}
  ,
  mounted() {
  }
  ,
  methods: {
    onClose() {
      this.open = false
    }
    ,
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    }
    ,
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        appType:"0",
        upNotes: null,
        upHeSize: null,
        upUrlType: null,
        upUrl: null,
        versionName: null,
        versionCode: null,
        upType: null,
        compulsoryUp: null,
        downloadUrl: null,
        createTime: null,
        remark: null,
      //  type:0
      }
      this.apkFileName = null;
      // this.$nextTick(() => {
      //   if (this.$refs.form) {
      //     this.$refs.form.resetFields()
      //   }
      // })
    }
    ,
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = 'Add'
    }
    ,
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getVersionInfo({ 'id': id }).then(response => {
        this.form = response.data
        // this.form.appType = Number(response.data.appType);
        this.open = true
        this.formTitle = 'Edit'
      })
    }
    ,
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateVersionInfo(this.form).then(response => {
              this.$message.success(
                'Updated successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addVersionInfo(this.form).then(response => {
              this.$message.success(
                'Created successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    /**
     * 文件上传前校验
     * @param {config.form.item} formItem 表单项
     * @param {*} fileInfo 文件详情, 见 a-upload 组件 customRequest 事件
     */
    fileBeforeUpload(fileInfo) {
      // 图片类型字段, 进行文件类型判断
      // Log.info('fileInfo', fileInfo);
      // if (!fileInfo.type.includes('apk') || !fileInfo.type.includes('wgt')) {
      //   this.$message.warning('请上传更新包');
      //   return false;
      // }
      return true;
    },
    /**
     * 文件上传请求自定义
     * @param {config.form.item} formItem 表单项
     * @param {*} fileInfo 文件详情, 见 a-upload 组件 customRequest 事件
     */
    fileUploadRequest(fileInfo) {
      console.log('uploadfileInfo', fileInfo);
      this.loading = true;
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          console.log('upload', res);
          this.loading = false;
          this.form.downloadUrl = res[0].url;
          this.apkFileName = null;
        },
      });
    },
  }
}
</script>
